/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "dreamroipixel",
            "endpoint": "https://818afnx723.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "dreamroishopifyauthorizer",
            "endpoint": "https://hen78jhl5d.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "dreamroistripeapi",
            "endpoint": "https://v1o3y9h870.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "dreamroitrackerapi",
            "endpoint": "https://tiezvnm91h.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ximqbyxhqvfddlb3kqukg6a7uu.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:e8ecf032-f557-47d6-b0b1-52f9dd55263c",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_yt8jVAfmn",
    "aws_user_pools_web_client_id": "2aker026vrhck4s6giednjpkqk",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "dreamroifrontend-production",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://deh3ivoznayyq.cloudfront.net",
    "aws_user_files_s3_bucket": "dreamroirecommenderproductmedia231118-production",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
